import { funlidayRequest } from './main';

export const updateFirstLogin = (action, nickname, referralCode = '') => {
  const params = { action, nickname, referralCode };

  return funlidayRequest.post(`updateFirstLogin`, params);
};

export const apiSendVerifyCodeLoginMaintenance = ({
  email,
  loginType = '0'
}) => {
  const params = { email, loginType };

  return funlidayRequest.post(`sendVerifyCodeLoginMaintenance`, params);
};

export const apiVerifyCodeLoginMaintenance = ({
  email,
  loginType = '0',
  verifyCode
}) => {
  const params = { email, loginType, verifyCode };

  return funlidayRequest.post(`verifyCodeLoginMaintenance`, params);
};
